import * as moment from 'moment';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';

import { Position, BreadcrumbItem } from '../../../entities/index';
import { TrackerService } from '../../../services/tracker.service';
import { Log } from '../../../utils/index';
import { IsoDateToStringPipe } from '../../../pipes/iso-date-to-string.pipe';

@Component({
  selector: 'app-position-list',
  templateUrl: './position-list.html'
})
export class PositionListComponent implements OnInit {
  trackerId: number;
  positions: Position[] = [];
  startDate: moment.Moment;
  endDate: moment.Moment;
  selectedDate: Date;
  loading = false;
  filterPosition: boolean;

  exportFromDate: string;
  exportToDate: string;
  fileUrlLoading = false;
  fileUrl: any = null;
  showDownloadLink = false;

  pageTitle = 'Positions Tracker #';
  titleSubText = '';
  breadcrumbs: BreadcrumbItem[] = [
    new BreadcrumbItem('Tracker List', 'map-marker', '/tracker'),
    new BreadcrumbItem('Tracker Detail', 'map-marker'),
    new BreadcrumbItem('Positions', 'map-marker')
  ];

  constructor(protected route: ActivatedRoute,
              protected trackerService: TrackerService,
              protected sanitizer: DomSanitizer) {
    this.trackerId = Number(route.snapshot.params.id);
    this.pageTitle += this.trackerId;
    this.breadcrumbs[1].link = '/tracker/' + this.trackerId;
    this.breadcrumbs[1].title += ' #' + this.trackerId;
    this.filterPosition = localStorage.getItem('filterPosition') === 'true';
  }

  @Log()
  ngOnInit() {
    this._loadPosition();
  }

  @Log()
  onDayChange() {
    this.fileUrl = null;
    this._loadPosition();
  }

  _loadPosition() {
    this.startDate = moment().startOf('day');
    this.endDate = null;

    let initFilters: any = {start: moment().startOf('day').toISOString()};
    this.exportFromDate = initFilters.start.split('.')[0];
    this.exportToDate = (new Date()).toISOString().split('.')[0];

    if (this.selectedDate) {
      this.startDate = moment(this.selectedDate).startOf('day');
      this.endDate = moment(this.selectedDate).endOf('day');
      this.exportFromDate = this.startDate.toISOString().split('.')[0];
      this.exportToDate = this.endDate.toISOString().split('.')[0];
      initFilters = {
        start: this.startDate.toISOString(),
        end: this.endDate.toISOString(),
        filter_by: "server_date"
      };
    }

    const isoDatePipe = new IsoDateToStringPipe();
    this.titleSubText = `From ${isoDatePipe.transform(this.startDate.toISOString())} to `;
    if (this.endDate) {
      this.titleSubText += isoDatePipe.transform(this.endDate.toISOString());
    } else {
      this.titleSubText += 'now';
    }

    this.loading = true;
    this.trackerService.getPositions(this.trackerId, initFilters).subscribe(
      (res: Position[]) => {
        this.positions = res;
        this.loading = false;
      },
      () => {
        this.loading = false;
      }
    );
  }

  changeFilter(isFilterPositionChecked: boolean) {
    localStorage.setItem('filterPosition', String(isFilterPositionChecked));
  }

  @Log('blue')
  exportTracker() {
    this.fileUrl = null;

    this.trackerService
      .export(this.trackerId, this.exportFromDate, this.exportToDate)
      .subscribe(
        (res: string) => {
          this.fileUrl = this.sanitizer.bypassSecurityTrustUrl(res);
        }
      );
  }

  @Log()
  onExportDateChange() {
    this.fileUrl = null;
  }
}



// WEBPACK FOOTER //
// /builds/weenect1/backofficev3/src/app/components/pages/position/position-list.component.ts